<template>
    <div class="left-aside">
        <div style="flex: 1;height: 100%;overflow-y: auto;" ref="emailContainer">
            <div v-for="(item, index) in dataList" :key="index"
                :class="selectMailIndex == index ? 'nav-item nav-item-selected' : 'nav-item'"
                @click="handleSelectMail(item, index)">
                <p class="email">{{ formatMailDate(item) }}</p>
                <p class="subject">From  {{ item.content }}</p>
                <p class="time">IP Address : {{ item.ip_address }}</p>
                <div style="text-align: right;">
                    <el-button type="danger" size="small" @click.stop="restoreInbox(item)">Remove From BlackList</el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {
    postRequest
} from '../../api/assistant'
import {
    formatDate
} from '../../utils/date'
import { Loading } from 'element-ui'
export default ({
    name: 'index',
    data() {
        return {
            showContentDialog: false,
            emailContent: '',
            selectMailIndex: 0,
            dataList: [],
        }
    },
    mounted() {
        this.requestData()
    },
    methods: {
        requestData() {
            let loadingInstance = Loading.service({
                text: 'Loading',
                fullscreen: true
            })
            postRequest({
                function: "getBlackList"
            }).then((res) => {
                this.selectMailIndex = 0
                this.dataList = res.data.data
            }).finally(() => {
                loadingInstance.close()
            })
        },
        restoreInbox(email) {
            this.$alert('你确定要从黑名单中移除吗？', '提示', {
                callback: action => {
                    if (action == 'confirm') {
                        postRequest({
                            function: "removeBlack",
                            id: email._id.$id
                        }).then((res) => {
                            this.$message.success('从黑名单列表中移除成功')
                            this.requestData()
                        })
                    }
                }
            })
        },
        formatMailDate(mail) {
            const create_time = mail.create_time
            const date = new Date(create_time * 1000)
            const utc = date.getTime() + date.getTimezoneOffset() * 60000
            const nd = new Date(utc + 8 * 60 * 60 * 1000)
            return formatDate(nd, 'yyyy-MM-dd hh:mm:ss')
        },
        handleSelectMail(email, index) {
            this.selectMailIndex = index
        },
    }
})
</script>
<style scoped lang="scss">
.left-aside {
    height: calc(100vh - 60px);
    display: flex;
    background-color: white;
    flex-direction: column;
    border-left: 1px solid #f5f5f5;
    box-sizing: border-box;

    .nav-item {
        cursor: pointer;
        padding: 10px 15px;
        box-sizing: border-box;
        width: 100%;
        color: #333;
        font-size: 16px;
        background-color: white;
        border-bottom: 1px solid #f5f5f5;

        .reply {
            display: inline-block;
            margin: 0px;
            font-size: 10px;
            color: red;
        }


        .email {
            font-size: 12px;
            color: #666;

            margin: 0px;
        }

        .time {
            margin-top: 5px;
            margin-bottom: 5px;
            color: #666;
            font-size: 12px;
        }

        .subject {
            margin: 5px 0px;
            color: #333;
            font-size: 12px;
            font-weight: bold;
        }

        &:hover {
            background-color: #f5f5f5;
        }
    }

    .nav-item-selected {
        background-color: #FFD9D4;

        &:hover {
            background-color: #FFD9D4;
        }
    }

    .nav-item:last-child {
        margin-bottom: 40px;
    }
}
</style>
